import {
  FormMetaModel,
  SmMetaInputModel,
  SmMetaLabelModel,
} from 'common/models/utility-models/meta-model';

export class RegisterStep3MetaModel extends FormMetaModel {
  constructor() {
    super(
      '',
      '',
      '',
      3,
      null,
      true,
      'step3',
      '',
      ' row align-items-start justify-content-start'
    );
  }

  override initProperties(): any {
    const formInfo = super.initProperties();
    const score10 = new SmMetaInputModel(
      'score10',
      'score10',
      'input',
      true,
      'col-12 col-md-4',
      1,
      1,
      '10th std Score (%)',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      '10th cutoff % is 60',
      true,
      true
    );
    const score12 = new SmMetaInputModel(
      'score12',
      'score12',
      'input',
      true,
      'col-12 col-md-4',
      1,
      2,
      '12th std Score (%)',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      '12th cutoff % is 60',
      true,
      true
    );

    const percentageLabel = new SmMetaLabelModel(
      'percentageLabel',
      'percentageLabel',
      'label',
      true,
      'col-12 mt-2 mb-2  ',
      1,
      3,
      'Please provide your Physics, Chemistry, Mathematics marks in percentage ',
      'text',
      '',
      false,
      true
    );
    const physicsMarks = new SmMetaInputModel(
      'physicsMarks',
      'physicsMarks',
      'input',
      true,
      'col-12 col-md-4',
      2,
      4,
      'Physics',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      'Physics cutoff % is 60',
      true,
      true
    );
    const chemistryMarks = new SmMetaInputModel(
      'chemistryMarks',
      'chemistryMarks',
      'input',
      true,
      'col-12 col-md-4',
      2,
      5,
      'Chemistry',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      'Chemistry cutoff % is 60',
      true,
      true
    );

    const mathematicsMarks = new SmMetaInputModel(
      'mathematicsMarks',
      'mathematicsMarks',
      'input',
      true,
      'col-12 col-md-4',
      2,
      6,
      'Mathematics',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      'Mathematics cutoff % is 60',
      true,
      true
    );
    const jeeScore = new SmMetaInputModel(
      'jeeScore',
      'jeeScore',
      'input',
      true,
      'col-12 col-md-4',
      3,
      7,
      'JEE Main/JEE Advance/CET (%)',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      `
Applicants from Tamil Nadu and Puducherry please put in your 12th Std Score`,
      true,
      true
    );

    return {
      formInfo,
      score10,
      score12,
      percentageLabel,
      physicsMarks,
      chemistryMarks,
      mathematicsMarks,
      jeeScore,
    };
  }
}
